import { render, staticRenderFns } from "./AdquisicionCofi.vue?vue&type=template&id=07e86554&scoped=true&lang=html&"
import script from "./AdquisicionCofi.vue?vue&type=script&lang=js&"
export * from "./AdquisicionCofi.vue?vue&type=script&lang=js&"
import style0 from "./AdquisicionCofi.vue?vue&type=style&index=0&id=07e86554&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e86554",
  null
  
)

export default component.exports